import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useResourceSummary
  from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard/useResourceSummary';
import {
  FDStack,
  FDIcon,
  FDBodyText,
  FDTitleText,
  FDPaper,
  FDTooltip,
} from '@facet-wealth/design';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classnames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    minWidth: theme.dimensions.xs,
    border: '1px solid #007099',
    borderRadius: theme.radius.md,
    background: theme.palette.common.white,
    padding: theme.spacing(2),
    cursor: 'pointer',

  },
  hover: {
    '&:hover': {
      background: 'transparent',
      borderColor: '#00506D',
    },
  },
  disabled: {
    cursor: 'not-allowed',
    pointerEvents: 'all !important',
    borderColor: '#757575ff',
  },
}));


export default function TransferTypeResourceSummaryCard({
  resource, onClick,
}) {
  const {
    title,
    subtitle,
    mainAction,
  } = useResourceSummary(resource);
  const classes = useStyles();
  const isDisabled = mainAction.relationship.meta('actions').length === 0 ?? true;
  const tooltipText = mainAction.unavailableReason ?? '';

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      onClick({ resource, action: mainAction });
    }
  };

  const handleClick = () => {
    if (!isDisabled) {
      onClick({ resource, action: mainAction });
    }
  };

  return (
    <FDTooltip title={isDisabled ? tooltipText : ''} placement="bottom">
      <div
        tabIndex={0}
        role="button"
        onKeyDown={handleEnter}
        onClick={handleClick}
        disabled={isDisabled}
        className={classnames(classes.root, {
          [classes.hover]: !isDisabled,
          [classes.disabled]: isDisabled,
        })}
      >
        <FDPaper flex={1} rounded appearance="flat">
          <FDStack direction="column" alignItems="center" spacing={1}>
            <FDIcon icon={mainAction?.icon} color={isDisabled ? 'textDisabled' : 'info'} size="md" />
            <FDTitleText align="center" color={isDisabled ? 'textDisabled' : 'textPrimary'} size="md" value={title} />
            <FDBodyText align="center" color={isDisabled ? 'textDisabled' : 'textPrimary'} size="sm" value={subtitle} />
          </FDStack>
        </FDPaper>
      </div>
    </FDTooltip>
  );
}

TransferTypeResourceSummaryCard.propTypes = {
  resource: PropTypes.instanceOf(fr.resource),
  onClick: PropTypes.func,
};
